import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { Scroller } from '../Scroller'
import { useEffectOnce, useWindowSize } from 'usehooks-ts'




const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const { width } = useWindowSize()
  const [height, setHeight] = useState(0)
  useEffectOnce(() => {
    setHeight(window.innerHeight)
  })

  const CM = colorMode === 'light' ? 'LM' : 'DM'
  let device:String
  
  if (width >= 1000){
    device = 'desktop'
  } else {
    device = 'mobile'
  }
  // const [width, setWidth] = useState<number | undefined>()
  // const windowSize = useWindowSize()
  // useEffect(() => {
  //   setWidth(0)
  // }, [])
  // useEffect(() => {
  //   setWidth(windowSize.width)
  // }, [windowSize.width])

  return (
    <AppContainer className={globalClasses.join(' ')} >
      <TextWidth>
        <p>Jakob ist traurig. Schon seit zehn Minuten scrollt er mit seinem Vater durch die H&M-Website. Er braucht etwas für den Sommer, luftig soll es sein, schön bunt und keinesfalls dürfen die Hosen Knöpfe, Reissverschlüsse, Haken oder ähnliche Gemeinheiten haben, das mag der Siebenjährige gar nicht. Doch gerade sind sein grösstes Problem die Farben und Muster. Es gibt Streifen und Dinos, Fussbälle, Camouflage und Motive aus der Comic-Serie «Peanuts». Was es kaum gibt: Orange, Gelb, Rot, Violett oder wenigstens ein knalliges Grün. Erst recht nicht zu finden: Glitzer und Pailletten. Dabei feiert die Oma bald ihren Geburtstag und der Erstklässler möchte mindestens so schick sein wie seine grosse Schwester, die für diese Gelegenheit einen goldenen Jumpsuit in den Warenkorb gelegt hat.</p>
        <p>Was Jakob und sein Vater sehen, kann vermutlich jeder bestätigen, der zuletzt ein Kleidungsgeschäft für Kinder betreten oder ein Shoppingportal aufgerufen hat. Von Anfang an ist alles nach Geschlechtern aufgeteilt, man muss sich entscheiden: Kauft man Socken für Jungs oder Mädchen? In sozialen Netzwerken kursiert hier der Witz: «Ich hätte eigentlich gerne Socken für Füsse.»</p>
        <p>Dass das gegenderte Angebot keine gefühlte Wahrheit, sondern Fakt ist, belegt nun eine Datenanalyse der Süddeutschen Zeitung (SZ). In die Auswertung sind Bilder und Beschreibungen von mehr als 20 000 Kleidungsstücken für Kinder unter zehn Jahren eingeflossen, Tausende Shirts und Shorts der Shoppingseiten Zalando, About You und H&M. Sie führen die Marken, die Kinder zwischen sechs und neun der Studie «Trend Tracking Kids 2022» zufolge «cool» finden. Die Ergebnisse zeigen: Die aktuelle Kindermode zementiert Geschlechterbilder.</p>
        <p>
        Die Verantwortung dafür weisen die Unternehmen allerdings von sich. Zalando erklärt auf Anfrage, das Angebot «bewusst geschlechtsneutraler zu gestalten, indem wir geschlechtsneutrale Farben und Stile in unser Sortiment integrieren». Ein Sprecher von H&M betont in einer Mail: «Unsere Kinderabteilungen sind in Jungen und Mädchen unterteilt, da die meisten unserer Kund*innen es vorziehen, auf diese Weise einzukaufen.» Als «Bullshit-Bingo des Gendermarketings» bezeichnet Almut Schnerring diese Berufung auf Kundenwünsche. Gemeinsam mit Sascha Verlan hat sie 2014 das Buch «Die Rosa-Hellblau-Falle» veröffentlicht, es ist bis heute das deutsche Standardwerk zum Thema. Sie legen daran unter Berufung auf zahlreiche wissenschaftliche Studien dar, wie Firmen seit mehr als 20 Jahren unfassbar viel Budget in die Geschlechtertrennung investieren und mit ihrer Werbung die Bilder produzieren. Jetzt die Verantwortung wieder auf den davon beeinflussten Einzelnen zu schieben, sei nicht fair, sagt Schnerring. Von About You kam bis zum Erscheinen dieses Textes keine Antwort auf entsprechende Anfragen.
          </p>
          <SubHeading>Für Mädchen kurz und knapp, für Jungs bequem</SubHeading>
        
        <p>Besonders eindrücklich zeigt sich die Differenz an den Hosen. Praktische Kleidungsstücke, die seit Jahrzehnten beiden Geschlechtern gleichermassen zustehen und theoretisch für alle gleich geschnitten sein könnten. Um herauszufinden, ob Shorts für Kinder das wirklich sind, hat die SZ die Umrisse Tausender Hosen mit Hilfe eines eigens dafür geschriebenen Programmes übereinandergelegt und verglichen. Denn um die Längen zu vergleichen, reicht es nicht, die Innenbeinlänge von Hosen zu messen. Diese hängt schliesslich immer mit der Kleidergrösse zusammen und unterscheidet sich im Alter zwischen zwei und zehn Jahren natürlich gewaltig.</p>
        <p>Um den Schnitt betrachten zu können, müssen die Schnitte als Ganzes verglichen werden. Das Programm hat dafür knapp 4000 Hosen digital abgepaust und die Umrisse aller Modelle übereinandergelegt.</p>
      </TextWidth>
      <Scroller
        defaultDistance={height/2}
        front={
          [<FrontElement >
            <TextWidth>
                <p>
                Bei den Jungen sieht das so aus. Die durchschnittliche Hose für Jungen geht etwa bis zur Mitte des Oberschenkels.
              </p>
            </TextWidth>
        </FrontElement>,
        <FrontElement>
          <TextWidth>
              <p>
              Anders bei den Mädchen: Ihre Hosen sind in den meisten Fällen um einiges knapper geschnitten, die Hose mittlerer Länge endet kurz unter dem Po.
            </p>
          </TextWidth>
        </FrontElement>,
        <FrontElement>
          <TextWidth>
              <p>
              Besonders deutlich zeigt es der direkte Vergleich der Längen: Für Jungen gibt es Shorts, für Mädchen Hotpants.
            </p>
          </TextWidth>
        </FrontElement>
        ]
        }
        back={(index) => {
          return (
            <BackElement>
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/pants_m_' + device + '_' + CM + '.png')})`,
                opacity: `${index <= 0 ? 1 : 0}`}}/>
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/pants_w_' + device + '_' + CM + '.png')})`,
                opacity: `${index === 1 ? 1 : 0}`}}/>
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/pants_mw_' + device + '_' + CM + '.png')})`,
                opacity: `${index >= 2 ? 1 : 0}`}}/>
              <div  style={{ 
                height: height + 'px'
              }}/>
            </BackElement>
          )
        }}
        
      />
      <div style={{ 
        height: height + 'px'
      }}/>
      <TextWidth>
        <p>Anatomisch ergibt das keinen Sinn, die Körper von Jungen und Mädchen unterscheiden sich in der betrachteten Altersgruppe kaum. Jungs sind lediglich etwas grösser und schwerer, dafür bräuchte es aber keine unterschiedlichen Schnitte, Eltern könnten einfach früher zur nächsten Grösse greifen. Dass die Hosen von Mädchen enger und kürzer sind, ist daher schlicht Ergebnis von Mode und Sozialisierung.</p>

        <p>«Die Kleidung für Mädchen – egal in welcher Altersgruppe – ist darauf ausgelegt, Haut zu zeigen und den Körper zu betonen», sagt Almut Schnerring. In der Logik dieser Märkte sind Mädchen in erster Linie kleine Frauen, bei ihnen ist Kleidung kein Selbstzweck, sondern soll gefallen. «Die Kleidung von Jungen hingegen ermöglicht Bewegung und gemütliches Dasein», sagt Almut Schnerring. Mit Cargoshorts klettert es sich besser als mit Hotpants – oder gar mit Miniröcken, die in dieser Analyse mangels Vergleichsmaterial gar nicht erst auftauchen.</p>

        <p>Neben den Hosenschnitten haben die Datenjournalisten T-Shirt-Farben der drei Online-Shops von Zalando, About You und H&M ausgewertet. Mehrfarbige Oberteile wurden dabei allen Farben zugeordnet, die das Muster dominieren. Manche Teile können deshalb mehr als einmal in der Auswertung vorkommen, ein blau-grün-gestreiftes Shirt gehört beispielsweise zu Blau und zu Grün. Das Ergebnis ist dennoch deutlich – und wie erwartet.</p>
      </TextWidth>


      <Scroller
        defaultDistance={height/2}
        front={
          [<FrontElement >
            <TextWidth>
                <p>
                Bei Shirts für Jungen ist eine der Hauptfarben Blau, gefolgt von Braun. Je häufiger eine Farbe vorkommt, desto grösser ist die Fläche, die sie in der Grafik einnimmt.
              </p>
            </TextWidth>
        </FrontElement>,
        <FrontElement>
          <TextWidth>
              <p>
              Bei den Angeboten für Mädchen zeigt sich ein anderes Bild: Plötzlich ist etwa jedes zweite Shirt in Rosa, Violett oder Rot gehalten.
            </p>
          </TextWidth>
        </FrontElement>
        ]
        }
        back={(index) => {
          
          return (
            <BackElement>
              <div style={{
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/chart_m_' + device + '.png')})`,
                opacity: `${index <= 0 ? 1 : 0}`}}/>
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/chart_w_' + device + '.png')})`,
                opacity: `${index >= 1 ? 1 : 0}`}}/>
            </BackElement>

            
          )
        }}
        
      />

      <div style={{ 
        height: height + 'px'
      }}/>

      <TextWidth>
        <p>«Farben sind eben nicht für alle da», sagt Almut Schnerring. Was als mädchenhaft gilt – Rosa, Lila, Rot – ist für Jungen tabu und andersherum. So beobachtet die neunjährige Luisa: «An Mädchenshirts ist immer irgendwo Pink dran.» Weil ihr Pink aber nicht gefällt, kauft sie in der Jungenabteilung und wird daher fast immer auch für einen solchen gehalten.</p>
        <p>Die einzige Ausnahme sind Braun- und Beigetöne. Sie nehmen bei beiden Grafiken die zweitgrösste Fläche ein, kommen also häufig vor, und auch als unisex verkaufte Shirts sind oft in diesen Farben gehalten. Was als «für alle» deklariert wird, ist daher meist keine wilde, fröhliche Mischung aus allem, sondern eine etwas fadere Jungenkollektion.</p>
        <SubHeading>Glamour für Mädchen, Funktionskleidung für Jungs</SubHeading>
        <p>Mädchen-Shirts sind zudem verspielter. In der Stichprobe gibt es für Mädchen im Vergleich zu Jungen drei Mal so viele Bordüren, vier Mal so viele Pailletten, zehn Mal so viele Zierschleifen. Sogar Muster sind inzwischen gegendert. Bei H&M sind die häufigsten Designs bei Mädchen Blumen und Punkte, für Jungen gibt es bei Zalando vor allem Streifen und Camouflage. Und selbst Tiere sind klar zugeordnet: Tiger und Dinosaurier für die Jungen, stark und wild quasi, und Schmetterlinge und Einhörner für Mädchen, zart und schön. Als wären die Dekors Codes für das rollenkonforme Verhalten, das von den Kindern erwartet wird.</p>
        <p>Wer hier benachteiligt wird, ist zunächst Einstellungssache: Dekorative Kleidung kann bei Mädchen dazu führen, dass ihnen aufgetragen wird, die Sachen nicht schmutzig zu machen, um adrett zu bleiben. Jungen haben dafür eine insgesamt viel geringere Auswahl und kaum kreative Möglichkeiten, sich besonders schick zu machen. Die Hemden und Fliegen, die in ihrer Grösse dafür angeboten werden, sind schliesslich kein Vergleich zu den Hunderten Kleidern, aus denen die Mädchen wählen können.</p>
        <p>T-Shirts, die auf den ersten Blick neutral sind, werden mithilfe von Aufschriften gelabelt. Zahlreiche Begriffe kommen bei einem Geschlecht häufig und bei dem anderen kaum vor. Das Wort «love» beispielsweise fand sich mehr als 200 Mal auf Kleidungsstücken für Mädchen, aber nur etwa 70 Mal auf solchen für Jungen. Auch träumen dürfen anscheinend nur Mädchen, der Begriff «dreamer» kommt bei ihnen 41 Mal vor, bei Jungen nur einmal. Je grösser die Schrift in der Wortwolke, desto kennzeichnender ist das Wort für das jeweilige Geschlecht.</p>
      </TextWidth>

      <Scroller
        defaultDistance={height/2}
        front={
          [<FrontElement >
            <TextWidth>
                <p>
                Mädchen sind also gefühlvoll unterwegs.
              </p>
            </TextWidth>
        </FrontElement>,
        <FrontElement>
          <TextWidth>
              <p>
              Bei Jungen ist – zumindest den Shirt-Slogans zufolge – Aktion angesagt. Sie surfen (139 Erwähnungen gegenüber 19 bei Mädchen) auf Wellen (171 gegenüber 15), sie haben Potenzial, sind schnell und entdecken was.
            </p>
          </TextWidth>
        </FrontElement>
        ]
        }
        back={(index) => {
          return (
            <BackElement >
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/text_w_' + device + '.png')})`,
                opacity: `${index <= 0 ? 1 : 0}`}}/>
              <div style={{ 
                height: height + 'px',
                backgroundImage: `url(${require('../../assets/text_m_' + device + '.png')})`,
                opacity: `${index >= 1 ? 1 : 0}`}}/>
              
            </BackElement>

          )
        }}
        
      />
      <div style={{ 
        height: height + 'px'
      }}/>

      <TextWidth>
        <p>Egal also, ob man Schnitte, Farben, Muster oder Slogans analysiert: Die Geschlechtertrennung ist streng, vielleicht strenger als jemals zuvor. In die Datenanalyse flossen zwar nur Artikel ein, die zum Erhebungszeitpunkt im Jahr 2022 auf den Webseiten angeboten wurden. Aus zahlreichen anderen Studien ist aber bekannt, dass das Gendermarketing bei Kleidung und Spielzeug kein schon immer dagewesenes Phänomen ist, sondern seit den Nullerjahren immer rigider wird. Es ist eine Reaktion der Industrie auf niedrige Geburtenraten und die steigende Bereitschaft von Eltern, immer mehr Geld für den Nachwuchs auszugeben. Wenn der rosa Schneeanzug der Schwester nicht vom Bruder aufgetragen werden kann, ist das schliesslich gut für den Umsatz.</p>
        <p>Diese Trennung führt dann auch dazu, dass es bestimmte Produkte auf dem Markt schlicht nicht gibt: Nachthemden mit Dinosauriern zum Beispiel, Röcke mit Fussbällen oder Cargo-Shorts mit Einhörnern. All das echte Wünsche von Jakob, sieben, der sich am Ende mit einem halben Dutzend farbenfrohen Fussballshorts und einem Rock mit Aprikosen zufriedengeben muss. Als er Letzteren in der Schule trägt, wird er den ganzen Tag gehänselt.</p>
        <p>An diesem Punkt wird deutlich, dass es eben nicht nur zwei getrennte Kategorien, sondern auch noch eine klare Hierarchie gibt. Die neunjährige Luisa mit kurzen Haaren und Handwerkerhosen wird zwar andauernd für einen Jungen gehalten, doch ganz so viel Spott wie Jakob im Aprikosenrock bekommt sie nicht ab. Viele Eltern wollen ihren Söhnen das ersparen und raten ihnen aus Angst vor Mobbing von weiblich konnotierten Artikeln ab, obwohl sie gleichzeitig betonen, selbst keine Probleme damit zu haben. Expertin Almut Schnerring will Eltern eher ermutigen, dem Nachwuchs den Rücken zu stärken. Es gehe um wesentlich mehr als um Farben und Stoffe, sagt sie: «Es geht um ganze Welten, die den einen vorenthalten und den anderen aufgedrängt werden.»</p>
      </TextWidth>




      
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  background-color: var(--site-background);
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

const SubHeading = styled.div`
    margin-bottom: 1.5rem;
    padding-top: 3rem;
    font-weight: 600;
    font-size: 2.4rem;
    font-family: var(--font-title);
    line-height: 2.7rem;
`

const FrontElement = styled.div<{ [k: string]: any }>`
  font-size: 18px;
  line-height: 23px;
  font-family: var(--font-sans-serif);
  /* min-height: 100vh; */
  position: relative;
  z-index: 1001;
  p,
  h4,
  h3 {
    font-family: var(--font-sans-serif);
  }
  img {
    /* z-index: 0; */
    max-width: 100%;
  }
  p{
    background-color: var(--site-background);
    padding: 1.5em;
    border: 1px;
    border-color: #000000e8;
    /* text-align:  center; */
    line-height: 1.5em;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px 0px, rgba(255, 255, 255, 0.2) 0px 0px 10px 0px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px 0px, rgba(255, 255, 255, 0.2) 0px 0px 10px 0px;
    border-radius: 5px;;
  }
  
`

const BackElement = styled.div`
  /* padding-top: 4vh; */
  @media only screen and (max-width: 542px) {
    padding-top: 0;
  }
  img {
    
    @media only screen and (max-width: 542px) {
    }
  }
  div{
    position: absolute;
    width: 100vw;
    background-size: contain;
    background-position: center, center;
    background-repeat: no-repeat;
    transition: opacity .6s linear;
    -webkit-transition: opacity .6s linear;
  }
  /* transition: opacity 1s ease-out; */
  
  `

export default MainComponent
